<template>
  <div>
    <div
      class="modal__backdrop"
      :class="{ 'modal__backdrop--toggled': getIsToggled && !backdropDisabled }"
      @click="isToggled = false"
    ></div>

    <avl-box
      class="modal"
      :class="{
        'modal--shown': isShown,
        'modal--toggled': getIsToggled,
        'modal--left-aligned': isLeftAligned,
      }"
    >
      <button class="modal__notch" @click="isToggled = !isToggled" v-if="isCollapsible">
        {{ getIsToggled ? notchTextWhenShown : notchTextWhenHidden }}
      </button>

      <div class="modal__inner">
        <slot></slot>
      </div>
    </avl-box>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data: () => ({ isToggled: true }),
    props: {
      isShown: { type: Boolean, required: true },
      isToggledInitial: { type: Boolean, default: true },
      isCollapsible: { type: Boolean, default: true },
      backdropDisabled: { type: Boolean },
      isLeftAligned: { type: Boolean, default: false },
      notchTextWhenShown: { type: String, default: 'Hide' },
      notchTextWhenHidden: { type: String, default: 'Show' },
    },
    watch: {
      // ensure that a modal is never revealed in an "un-toggled"
      // state unless it `isToggledInitial` is set to false
      isShown(isShown) {
        if (this.isToggledInitial && isShown) this.isToggled = true;
      },
      isToggled(value) {
        this.$store.commit('layout/setModalIsOpened', value);
      },
    },
    computed: {
      ...mapGetters(['gameIsCreated']),
      getIsToggled() {
        return this.isShown && this.isToggled;
      },
    },
    created() {
      this.isToggled = this.isToggledInitial;
    },
  };
</script>

<style scoped lang="scss">
  .modal {
    $self: &;

    opacity: 0;
    pointer-events: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    width: 300px;
    //
    transition: transform 300ms 100ms, opacity 200ms 400ms;
    //
    position: fixed;
    z-index: z('modal');
    bottom: 0;
    //
    left: 50%;
    transform: translate(-50%, 100%);

    &--left-aligned {
      border-bottom-right-radius: 4px;
      width: 280px;
      //
      left: 0;
      top: 50%;
      transform: translate(-100%, -50%);
    }

    &--shown {
      opacity: 1;
      pointer-events: initial;
      transition: transform 300ms 100ms, opacity 100ms;
    }

    &--toggled {
      transform: translate(-50%, 0);
    }

    &--left-aligned#{$self}--toggled {
      transform: translate(0, -50%);
    }

    &__backdrop {
      background: #000000;
      //
      position: fixed;
      top: 0;
      left: -9999px;
      z-index: z('modal');
      //
      width: 100vw;
      height: 100vh;
      //
      transition: opacity 300ms 100ms, left 0ms 400ms;
      opacity: 0;
      pointer-events: none;

      &--toggled {
        transition: opacity 300ms, left 0ms 0ms;
        left: 0;
        opacity: 0.4;
        pointer-events: all;
      }
    }

    &__notch {
      background: inherit;
      padding: 0;
      border: none;
      border-bottom: 1px solid lightgray;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      //
      width: 60px;
      height: 32px;
      //
      position: absolute;
      top: 0;
      left: 0;
      transform: translateY(-100%);
    }

    &--left-aligned &__notch {
      transform-origin: bottom center;
      //
      font-size: 10px;
      width: 48px;
      height: 24px;
      //
      left: auto;
      right: 0;
      top: 24px;
      transform: translate(50%, 0) rotate(90deg);

      @include tablet-sm() {
        font-size: 14px;
        width: 60px;
        height: 32px;
        //
        top: 50%;
        transform: translate(50%, -100%) rotate(90deg);
      }
    }

    &__inner {
      height: 100%;
      width: 100%;
      opacity: 0;
      transition: opacity 300ms;
    }

    &--toggled &__inner {
      opacity: 1;
      transition: opacity 300ms 100ms;
    }
  }
</style>
